(() => {
  const cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  const jsUrl = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';

  function loadSwiperCss() {
    if (document.querySelector(`link[href="${cssUrl}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
  }

  function loadSwiperScript() {
    if (window.Swiper) return Promise.resolve();
    if (!window.olcSwiperPromise) {
      window.olcSwiperPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${jsUrl}"]`);
        if (existing) {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }
        const script = document.createElement('script');
        script.src = jsUrl;
        script.defer = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });
    }
    return window.olcSwiperPromise;
  }

  function initCarousel(carousel) {
    if (carousel.dataset.swiperInitialized === 'true' || !window.Swiper) return;

    const swiperElement = carousel.querySelector('[data-article-carousel-swiper]');
    const progress = carousel.querySelector('[data-carousel-fill]');
    const count = carousel.querySelector('[data-carousel-count]');
    const prevButton = carousel.querySelector('[data-carousel-prev]');
    const nextButton = carousel.querySelector('[data-carousel-next]');

    if (!swiperElement) return;

    const total = swiperElement.querySelectorAll('.swiper-slide').length;
    if (!total) return;

    const updateIndicator = (swiper) => {
      const perView = Math.max(1, Math.floor(swiper.params.slidesPerView) || 1);
      const current = Math.min(swiper.activeIndex + perView, total);
      if (progress) progress.style.width = `${(current / total) * 100}%`;
      if (count) count.textContent = `${current}/${total}`;
      if (prevButton) prevButton.disabled = swiper.isBeginning;
      if (nextButton) nextButton.disabled = swiper.isEnd;
    };

    const swiper = new window.Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      grabCursor: total > 1,
      a11y: { enabled: true },
      breakpoints: {
        768: { slidesPerView: 1.5, spaceBetween: 20 },
        992: { slidesPerView: 2, spaceBetween: 24 },
        1440: { slidesPerView: 2.5, spaceBetween: 24 },
        1920: { slidesPerView: 3, spaceBetween: 32 },
      },
      on: {
        init: updateIndicator,
        slideChange: updateIndicator,
        breakpoint: updateIndicator,
        resize: updateIndicator,
      },
    });

    if (prevButton) prevButton.addEventListener('click', () => swiper.slidePrev());
    if (nextButton) nextButton.addEventListener('click', () => swiper.slideNext());

    carousel.dataset.swiperInitialized = 'true';
    carousel._articleSwiper = swiper;
  }

  function bootArticleCarousels(root = document) {
    const carousels = root.querySelectorAll('[data-article-carousel]');
    if (!carousels.length) return;

    loadSwiperCss();
    loadSwiperScript().then(() => {
      carousels.forEach(initCarousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootArticleCarousels());
  } else {
    bootArticleCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => bootArticleCarousels(event.target));
})();
